export default __webpack_public_path__ + "158c82cf06ed9030c4af29b8f2aaa3e2.png";